import { render, staticRenderFns } from "./install.vue?vue&type=template&id=02c4568c&scoped=true&"
import script from "./install.vue?vue&type=script&lang=ts&"
export * from "./install.vue?vue&type=script&lang=ts&"
import style0 from "./install.vue?vue&type=style&index=0&id=02c4568c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c4568c",
  null
  
)

export default component.exports